import { VoiceApp } from './app';
import { browserAdapters } from './adapters';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Service worker registration failed', err);
    });
}

const appEl = document.getElementById('app');
if (!appEl) {
  throw new Error('No #app element found in the page');
}
new VoiceApp(appEl, browserAdapters);
